export default __webpack_public_path__ + "static/media/img-logo-cloud-aws.9e5c07e1.svg";